module.exports = __webpack_public_path__ + "static/media/Error_IMG.8c2984c8.svg";